import { useEffect, useState } from "react";
import DemoCard from "./demo-card";
import axiosInstance from "../axios";

export default function ConfirmedTutors() {
  const [isMobile, setIsMobile] = useState(false);
  const [activeContainer, setActiveContainer] = useState();
  const [tutorsData, setTutorsData] = useState([]);
  const [loading, setLoading] = useState(true);
  let _dealData = JSON.parse(localStorage.getItem("dealData"));
  useEffect(() => {
    // Comment out API call for demo purposes
    setLoading(true);
    let dealId = _dealData.id;
    axiosInstance
      .get(`v1/cre/student/recommendation/process-for-student?dealings_id=${dealId}&page=1&limit=2500`)
      .then(response => {
        setActiveContainer(() => "Confirmed");
        if (response.data.data) {
          setTutorsData(() => response.data.data.data?.filter(item => item.status === "CONFIRMED"));
        }
      })
      .catch(err => {
        // console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });

    setActiveContainer("Confirmed");
    // setTutorsData(dummyTutors);
    setIsMobile(() => window.innerWidth <= 768);
  }, []);

  const makeTitle = string => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "80vh",
        }}>
        <div className="loading">
          <img src="./book-loader.gif" alt="Loading..." />
        </div>
      </div>
    );
  }

  return (
    <div className="confirmed-tutors--container">
      {tutorsData.length !== 0 ? (
        <div className="confirmed-tutors--cards--wrapper">
          {tutorsData.map((data, index, array) => {
            return <DemoCard key={data.id} data={data} from={"confirmed"} />;
          })}
        </div>
      ) : !tutorsData.length ? (
        <div
          style={{
            color: "rgba(130, 130, 130, 1)",
            fontSize: "14px",
            fontWeight: "600",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}>
          No pending tutors at the moment
        </div>
      ) : (
        <div
          style={{
            color: "rgba(130, 130, 130, 1)",
            fontSize: "14px",
            fontWeight: "600",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}>
          No Confirmed Tutors Assigned to you
        </div>
      )}
    </div>
  );
}
